import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addProductType({ commit }, item) {
    return this.$axios.$post('admin/productTypes/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeProductType({ commit }, item) {
    return this.$axios.$delete(`admin/productTypes/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateProductType({ commit }, item) {
    return this.$axios.$put(`admin/productTypes/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchProductTypes({ commit }) {
    return this.$axios.$get('admin/productTypes').then((response) => {
      commit('load', response.data)
    })
  },
}
